import {lazy} from 'react';

const RemoteAccessViewAsync = lazy(() => import('./RemoteAccessView'));

export {RemoteAccessViewAsync};
